import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48f13007"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    class: "form",
    ref: "form",
    model: _ctx.formBody,
    rules: _ctx.rules,
    size: "small"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        label: "客户名称",
        name: "customer_name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            value: _ctx.formBody.customer_name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formBody.customer_name) = $event)),
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "客户地址",
        name: "customer_address"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            value: _ctx.formBody.customer_address,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formBody.customer_address) = $event)),
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "签约人",
        name: "sign_man"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            value: _ctx.formBody.sign_man,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formBody.sign_man) = $event)),
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "签约电话",
        name: "sign_phone"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            value: _ctx.formBody.sign_phone,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formBody.sign_phone) = $event)),
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "合同金额",
        name: "sum_amount"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.sum_amount,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formBody.sum_amount) = $event)),
            valueModifiers: { number: true },
            "addon-after": "元",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "服务期限（年）",
        name: "duration"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.duration,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formBody.duration) = $event)),
            valueModifiers: { number: true },
            "addon-after": "年",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "月服务费",
        name: "month_money"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.month_money,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formBody.month_money) = $event)),
            valueModifiers: { number: true },
            "addon-after": "元 / 月",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "年服务费",
        name: "year_money"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.year_money,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formBody.year_money) = $event)),
            valueModifiers: { number: true },
            "addon-after": "元 / 年",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "赔偿金额（万元）",
        name: "compensation_amount"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.compensation_amount,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formBody.compensation_amount) = $event)),
            valueModifiers: { number: true },
            "addon-after": "万元",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "设备押金",
        name: "deposit"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.deposit,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formBody.deposit) = $event)),
            valueModifiers: { number: true },
            "addon-after": "元",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "视频主机数量",
        name: "videohost_count"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.videohost_count,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formBody.videohost_count) = $event)),
            valueModifiers: { number: true },
            "addon-after": "台",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "报警主机数量",
        name: "alarmhost_count"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.alarmhost_count,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formBody.alarmhost_count) = $event)),
            valueModifiers: { number: true },
            "addon-after": "台",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "NVR通道数",
        name: "nvr_chana_channel_count"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            type: "number",
            value: _ctx.formBody.nvr_chana_channel_count,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formBody.nvr_chana_channel_count) = $event)),
            valueModifiers: { number: true },
            "addon-after": "个",
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "备注",
        name: "remark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            size: "large",
            value: _ctx.formBody.remark,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formBody.remark) = $event)),
            "auto-size": { minRows: 2, maxRows: 5 },
            disabled: _ctx.disabled
          }, null, 8, ["value", "disabled"])
        ]),
        _: 1
      }),
      (!_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_a_form_item, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "large",
                        block: "",
                        type: "primary",
                        onClick: _ctx.submit,
                        loading: _ctx.isLoading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "large",
                        block: "",
                        onClick: _ctx.reset,
                        disabled: _ctx.isLoading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}